import { render, staticRenderFns } from "./BirdDogItemNotes.vue?vue&type=template&id=fcbf0e86&scoped=true&"
import script from "./BirdDogItemNotes.vue?vue&type=script&lang=js&"
export * from "./BirdDogItemNotes.vue?vue&type=script&lang=js&"
import style0 from "./BirdDogItemNotes.vue?vue&type=style&index=0&id=fcbf0e86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbf0e86",
  null
  
)

export default component.exports